const MOTION_SLUG_PATTERN = /^([\w-]+)-(\d+)$/

export const extractMotionUrl = (slugWithId: string) => {
  const matches = slugWithId.match(MOTION_SLUG_PATTERN)
  return matches ? { slug: matches.at(1), docId: Number(matches.at(2)) } : null
}
